module.exports = __webpack_public_path__ + "static/img/user.df722c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/user.jpg
// module id = 1Bnj
// module chunks = 1